module.exports = __webpack_public_path__ + "static/img/obudowa_plytki.115e829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/obudowa_plytki.png
// module id = fpf/
// module chunks = 1